import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiEpDatafanToken {
}
ApiEpDatafanToken.get = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/datafan/token`,
    method: "GET",
});
//# sourceMappingURL=datafan_token.js.map